import httpService from "./http.service";

const locationEndpoint = "location/";

const locationService = {
  get: async (taskId) => {
    const { data } = await httpService.get(locationEndpoint + taskId);
    return data;
  },
};

export default locationService;
